import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="#12033d" fillRule="evenodd" d="M2.1 7.22L2 7.06l.76-.56.1.15c2.61 3.7 5.7 7 9.2 9.82a48.08 48.08 0 009.07-9.8l.11-.17.76.56-.11.16a49.02 49.02 0 01-9.43 10.14c-.23.19-.57.19-.8 0A49.6 49.6 0 012.1 7.22z" clipRule="evenodd" /></svg>;